const API_URL = process.env.REACT_APP_API_URL;

//Get ticket files
export async function getTicketFiles(ticketId) {
  const response = await fetch(`${API_URL}/ticket/${ticketId}/fichiers`, {
    method: "GET",
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error("Non authentifié");
  }

  return response.json();
}

//Upload ticket files
export async function uploadTicketFiles(ticketId, file) {
  const formData = new FormData();
  formData.append("fichier", file);

  const response = await fetch(`${API_URL}/ticket/${ticketId}/fichier`, {
    method: "POST",
    credentials: "include",
    body: formData,
  });

  if (!response.ok) {
    throw new Error("Non authentifié");
  }

  return response.json();
}

//Delete ticket file
export async function deleteTicketFile(ticketId, fileId) {
  const response = await fetch(`${API_URL}/ticket/${ticketId}/fichier/${fileId}`, {
    method: "DELETE",
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error("Non authentifié");
  }

  return response.json();
}
// Download ticket file
export async function downloadTicketFile(ticketId, fileId, filename) {
  const response = await fetch(
    `${API_URL}/ticket/${ticketId}/fichier/${fileId}/telecharger`,
    {
      method: "GET",
      credentials: "include",
    }
  );

  if (!response.ok) {
    const text = await response.text();
    console.error("Download error:", response.status, text);
    throw new Error("Erreur lors du téléchargement");
  }

  const blob = await response.blob();

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.download = filename;

  document.body.appendChild(link);
  link.click();
  link.remove();

  window.URL.revokeObjectURL(url);
}

export async function viewTicketFile(ticketId, fileId) {
  const response = await fetch(
    `${API_URL}/ticket/${ticketId}/fichier/${fileId}/telecharger`,
    {
      method: "GET",
      credentials: "include",
    }
  );

  if (!response.ok) {
    throw new Error("Erreur lors de l'ouverture du fichier");
  }

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  
  window.open(url, "_blank");

}